export const ProfitBoostEvent = {
  ProfitBoostClick: 'profit_boost_click',
  ProfitBoostContinuePaymentClick: 'profit_boost_continue_payment_click',
  ProfitBoostConfirmClick: 'profit_boost_confirm_click',
  ProfitBoostAddPositionConfirmClick: 'profit_boost_add_position_confirm_click',
  ProfitBoostFlipPositionConfirmClick: 'profit_boost_flip_position_confirm_click',
  InstantFlipClick: 'instant_flip_click',
  ProfitBoostAvailabilityClick: 'profit_boost_availability_click',
} as const;

export interface ProfitBoostEventDataType {
  // https://www.notion.so/prextech/profit_boost_click-1a0eb32ad227801fa902d2d03f605123
  [ProfitBoostEvent.ProfitBoostClick]: {
    event_location: string;
    position_id: string;
    symbol: string;
    quantity: number;
    leverage: number;
    current_price: number;
    side: 'buy' | 'sell';
    entry_price?: number;
    mark_price?: number;
    liquidation_price?: number;
    margin_usdt: number | null;
    unrealized_pnl: number | null;
    unrealized_pnl_percentage: number | null;
    position_mode: 'oneway' | 'multiposition';
  };
  [ProfitBoostEvent.ProfitBoostContinuePaymentClick]: {
    event_location: string;
    position_id: string;
    boost_cost: number;
    discount_rate: number; // 0.5 (50%), 0.25 (25%)
    duration: number;
    remaining_boost: number;
  };
  // https://www.notion.so/prextech/profit_boost_confirm_click-1a1eb32ad227805d83f5cd6728ea6c80
  [ProfitBoostEvent.ProfitBoostConfirmClick]: {
    event_location: string;
    position_id: string;
    boost_cost: number;
    discount_rate: number; // 0.5 (50%), 0.25 (25%)
    duration: number;
    remaining_boost: number;
  };
  // https://www.notion.so/prextech/profit_boost_add_position_confirm_click-1a1eb32ad227800e9081c890b2533ea4
  [ProfitBoostEvent.ProfitBoostAddPositionConfirmClick]: {
    position_id: string;
    event_location: string;
  };
  // https://www.notion.so/prextech/profit_boost_flip_position_confirm_click-1a0eb32ad22780958610ee18a2a9e5f6
  [ProfitBoostEvent.ProfitBoostFlipPositionConfirmClick]: {
    position_id: string;
    event_location: string;
  };
  //https://www.notion.so/prextech/instant_flip_click-1a1eb32ad22780d5a197fd566098559a
  [ProfitBoostEvent.InstantFlipClick]: {
    event_location: string;
    position_id: string;
    profit_boost_mode: boolean;
    position_mode: 'oneway' | 'multiposition';
    symbol: string;
    leverage: number;
    current_price: number;
    entry_price?: number;
    mark_price?: number;
    liquidation_price: number;
    side: 'buy' | 'sell';
    margin_usdt: number | null;
    unrealized_pnl: number | null;
    unrealized_pnl_percentage: number | null;
  };
  [ProfitBoostEvent.ProfitBoostAvailabilityClick]: {
    symbol: string;
  };
}
